import React from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Button,
  useMediaQuery,
  Grid,
} from "@chakra-ui/react";
import Wrapper from "../../../common/Wrapper";
import heroImg from "../../../../assets/heroImg.png";

const FirstLayer = () => {
  const [isMobile] = useMediaQuery("(max-width: 501px)");

  return (
    <Wrapper opt color>
      <Grid
        gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }}
        w={["100%", "100%", "100%", "100%"]}
        pt="50px"
        pb={isMobile ? "44px" : "100px"}
        flexDir={["column", "column", "row", "row"]}
        justifyContent="space-between"
      >
        <Box
          mt="55px"
          flex={1.2}
          w={["100%", "100%", "100%", "100%"]}
          textAlign={{ base: "center", md: "left" }}
        >
          <Box>
            <Heading fontSize={["30px", "40px", "40px", "50px"]}>
              Fastamoni: Innovating Financial Solutions for Education and
              Business
            </Heading>
          </Box>
          <Text mt="20px" mb="23px" fontSize={["14px", "16px", "20px"]}>
            Empower Your Finances with EduPali and BizFlex Africa. Discover
            Fastamoni's cutting-edge financial technology platform, designed to
            simplify and enhance your financial management across various
            domains.
          </Text>

          <Button mb="52px" w={isMobile ? "full" : "fit-content"} h="60px">
            Explore Our Products
          </Button>
        </Box>

        <Flex
          flex={1}
          alignItems="center"
          justifyContent={["center", "center", "flex-end", "flex-end"]}
        >
          <Image
            h={["unset", "fit-content"]}
            src={heroImg}
            w={["320px", "500px", "500px", "600px"]}
          />
        </Flex>
      </Grid>
    </Wrapper>
  );
};

export default FirstLayer;
